import { render } from "./MobileFooterActions.vue?vue&type=template&id=bd0c278e&scoped=true&ts=true"
import script from "./MobileFooterActions.vue?vue&type=script&lang=ts"
export * from "./MobileFooterActions.vue?vue&type=script&lang=ts"

import "./MobileFooterActions.vue?vue&type=style&index=0&id=bd0c278e&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd0c278e"]])

export default __exports__